import { useMutation, useQueryClient } from "@tanstack/react-query";
import { adminApi } from "../api/adminApi";

export function useUpdateUserAccessMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, trialAte, assinaturaAte }) =>
      adminApi.updateUserAccess(id, { trialAte, assinaturaAte }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin", "users"] });
      // o admin pode ter alterado a própria conta
      queryClient.invalidateQueries({ queryKey: ["auth", "me"] });
    },
  });
}
